import React from 'react';

import moment from 'moment';

import Collapse from '~/components/Collapse';

import ItemDetail from '../ItemDetail';
import ItemDetailSkeleton from '../ItemDetail/ItemDetailSkeleton';
import { Container } from './styles';

export interface FixedDetail {
  label: string;
  value: string;
  icon?: JSX.Element;
  renderCondition?: boolean;
}

interface FixedDetailsProps {
  details: Array<FixedDetail>;
  columns: number;
  loading?: boolean;
}

moment.locale('pt-br');

const FixedDetails: React.FC<FixedDetailsProps> = ({
  details,
  loading,
  columns,
}) => {
  const renderItem = (detail: FixedDetail) =>
    loading ? (
      <ItemDetailSkeleton showIcon={!!detail.icon} />
    ) : (
      <ItemDetail
        label={detail.label}
        value={detail.value}
        icon={detail.icon}
      />
    );

  return (
    <Collapse label="Detalhes">
      <Container numberOfColumns={columns}>
        {details.map(
          (detail) => detail.renderCondition !== false && renderItem(detail),
        )}
      </Container>
    </Collapse>
  );
};

export default FixedDetails;
